<template>
  <zm-drawer
    ref="drawer"
    @ok="handleSubmit"
    :title="title"
    :width="drawerWidth"
    :visible="visible"
    @cancel="open(false)"
  >
    <div slot="drawerBody" class="induct_application">
      <a-form :form="form">
        <!-- 入职确认 -->
        <a-row>
          <a-col :span="24">
            <a-form-item :labelCol="labelCol3" :wrapperCol="wrapperCol3" label="入职确认">
              <a-switch
                style="margin: 2px 8px 6px 0"
                size="small"
                :checked="form.getFieldValue('entry')"
                v-decorator="['entry', { rules: [{ required: true, message: '请选择是否入职！' }] }]"
              />
              <span>{{ form.getFieldValue('entry') ? '同意' : '拒绝' }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="备注">
              <a-textarea
                placeholder="请输入备注"
                :rows="3"
                v-decorator="['remark', { rules: [{ required: !form.getFieldValue('entry'), message: '请填写备注！' }] }]"
              />
            </a-form-item>
          </a-col>
        </a-row>

        <!-- 信息补充 -->
        <template v-if="form.getFieldValue('entry')">
          <zm-label title="信息补充" />
          <a-row>
            <a-col :span="colSpan">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="在岗类型">
                <a-select
                  :allowClear="true"
                  placeholder="请选择在岗类型"
                  v-decorator="['jobStatus', { rules: [{ required: true, message: '请选择在岗类型！' }] }]"
                >
                  <a-select-option v-for="(option, index) in jobStatusList" :key="index" :value="option.value">
                    {{ option.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="colSpan">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="人员角色">
                <a-select
                  :allowClear="true"
                  placeholder="请选择人员角色"
                  mode="multiple"
                  :maxTagCount="2"
                  showSearch
                  optionFilterProp="children"
                  :filterOption="filterOption"
                  v-decorator="['roleIds', { rules: [{ required: true, message: '请选择人员角色!' }] }]"
                >
                  <a-select-option v-for="(item, index) in roleList" :value="item.id" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="colSpan">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="部门主管">
                <a-input
                  disabled
                  v-model="model.deptHeader"
                />
              </a-form-item>
            </a-col>
            <a-col :span="colSpan">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="入职日期">
                <a-date-picker
                  style="width: 100%"
                  placeholder="请选择入职日期"
                  v-decorator="['entryDate', { rules: [{ required: true, message: '请选择入职日期！' }] }]"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="colSpan">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="籍贯">
                <a-cascader
                  :options="areaList"
                  :showSearch="{ filter }"
                  placeholder="请选择籍贯"
                  changeOnSelect
                  v-decorator="['birthPlace', { rules: [{ required: false, message: '请选择籍贯！' }] }]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="colSpan">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="身份证">
                <a-input
                  placeholder="请输入身份证号码"
                  autocomplete="off"
                  :allowClear="true"
                  v-decorator="['identityNum', { rules: [{ required: false }] }]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="colSpan">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="政治面貌">
                <a-select
                  :allowClear="true"
                  placeholder="请选择政治面貌"
                  v-decorator="['politicalStatus', { rules: [{ required: false, message: '请选择政治面貌!' }] }]"
                >
                  <a-select-option v-for="(item, index) in politicalList" :key="index" :value="item.code">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="colSpan">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="婚姻状况">
                <a-select
                  :allowClear="true"
                  placeholder="请选择婚姻状况"
                  showSearch
                  optionFilterProp="children"
                  v-decorator="['maritalStatus', { rules: [{ required: false, message: '请选择婚姻状况!' }] }]"
                >
                  <a-select-option v-for="(item, index) in maritalStatusList" :key="index" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="现住址">
                <a-input
                  placeholder="请输入现住址"
                  autocomplete="off"
                  :allowClear="true"
                  v-decorator="['address', { rules: [{ required: false }] }]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="colSpan">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="员工编号">
                <a-input
                  placeholder="请输入员工编号"
                  autocomplete="off"
                  :allowClear="true"
                  v-decorator="['userNumber', { rules: [{ required: true, message: '请输入员工编号！' }] }]"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="初评附件">
                <zm-upload
                  ref="uploadScore"
                  title="上传"
                  :baseUrl="$sysInfo.apiRemote"
                  :headers="headers"
                  :list="scoreFileList"
                  acceptType="txt,doc,docx,xls,xlsx,pdf,ppt,pptx,jpeg,jpg,png"
                  @handleUpload="handleUpload"
                ></zm-upload>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="offer附件">
                <zm-upload
                  ref="uploadOffer"
                  title="上传"
                  :baseUrl="$sysInfo.apiRemote"
                  :headers="headers"
                  :list="offerFileList"
                  acceptType="txt,doc,docx,xls,xlsx,pdf,ppt,pptx,jpeg,jpg,png"
                  @handleUpload="handleOfferUpload"
                ></zm-upload>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
        
        <!-- 基础信息 -->
        <zm-label title="基础信息" />
        <a-row class="base_info">
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="姓名">
              <span>{{ model.userName }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="性别">
              <span>{{ model.gender == 1 ? '男' : model.gender == 2 ? '女' : '' }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="应聘岗位">
              <span>{{ model.departmentJobStr }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="所属部门">
              <span>{{ model.applyDepartmentStr }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="base_info">
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="实习岗">
              <span>{{ model.internship ? '是' : '否' }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="在职状态">
              <span>{{ model.workStatus === 2 ? '在职' : '待业' }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="最高学历">
              <span>{{ model.educationStr }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="毕业院校">
              <span>{{ model.school }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="base_info">
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="电子邮箱">
              <span>{{ model.email }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="手机号码">
              <span>{{ model.tel }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="目前年薪">
              <span>{{ model.currentAnnualSalary }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="期望年薪">
              <span>{{ model.itemAnnualSalary }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="base_info">
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="邀约平台">
              <span>{{ model.invitePlatformStr }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="预约时间">
              <span>{{ formatTime(model.planInterviewTime, 'YYYY-MM-DD HH:mm') }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="面试官">
              <span>{{ model.interviewerName }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="base_info">
          <a-col :span="12">
            <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="简历附件">
              <zm-preview
                :list="model.fileList"
                :previewUrl="$sysInfo.previewUrl"
                :baseUrl="$sysInfo.apiRemote"
                :account="$sysInfo.previewAccount"
                :token="$sysInfo.previewToken"
                :jwtToken="$store.state.user.token"
                downloadUrl="/interviewee/file/"
              ></zm-preview>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </zm-drawer>
</template>
<script>
import moment from 'moment'
import { inductApplication, insertApplicant, rejectInduction, updateApplicant } from '@/api/applicant'
import { getAllRoleList, getAreaList, getDeptInfo } from '@/api/baseInfo'
import { deleteChildren } from '@/utils/util'
import { getDictInfoByCode } from '@/api/dict'
export default {
  name: 'inductApplicant',
  computed: {
    drawerWidth () {
      const width = window.innerWidth - 200
      return width
    }
  },
  data () {
    return {
      title: '操作',
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'applicant' }),
      visible: false,
      defaultModel: {},
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      labelCol3: {
        xs: { span: 24 },
        sm: { span: 2 }
      },
      wrapperCol3: {
        xs: { span: 24 },
        sm: { span: 22 }
      },
      colSpan: 6,

      jobStatusList: [
        { value: 1, label: '正式' },
        { value: 2, label: '试用' },
        { value: 3, label: '实习' }
      ],
      roleList: [],
      politicalList: [],
      areaList: [],
      maritalStatusList: [
        { value: 1, label: '已婚' },
        { value: 0, label: '未婚' }
      ],

      headers: {
        Authorization: this.$store.state.user.token
      },
      scoreFileList: [],
      offerFileList: []
    }
  },
  methods: {
    formatTime (time, type) {
      return moment(time).format(type || 'YYYY-MM-DD')
    },
    initDictData () {
      // 获取部门主管
      getDeptInfo(this.model.applyDepartment).then(res => {
        if (res.status === 0) {
          const headerInfo = res.data.headList
          if (headerInfo && headerInfo.length) {
            const names = headerInfo.map(item => { return item.headName }).join(',')
            this.$set(this.model, 'deptHeader', names)
          }
        }
      })
      // 获取人员角色
      getAllRoleList().then(res => {
        if (res.status === 0) {
          this.roleList = res.data
        }
      })
      // 获取政治面貌
      getDictInfoByCode({ pCode: 'POLITICAL' }).then(res => {
        if (res.status === 0) {
          this.politicalList = res.data
        }
      })
      // 获取地区数据
      getAreaList().then(res => {
        const data = deleteChildren(res.data)
        this.areaList = data
      })
    },
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.visible = flag
      if (flag) {
        this.initDictData()
        this.$nextTick(() => {
          this.form.setFieldsValue({ entry: true })
        })
      } else {
        this.model = {}
      }
    },
    // 提交表单
    handleSubmit () {
      this.form.validateFieldsAndScroll(async (err, value) => {
        if (!err) {
          const params = { ...value }
          params.reason = params.remark
          const status = this.form.getFieldValue('entry')
          if (status) {
            // 同意入职
            params.intervieweeId = this.model.id
            params.roleIds = params.roleIds.join(',')
            params.deptId = this.model.applyDepartment
            if (params.birthPlace) {
              params.province = params.birthPlace[0] || ''
              params.city = params.birthPlace[1] || ''
              params.district = params.birthPlace[2] || ''
            }
            params.entryDate = this.formatTime(params.entryDate)
            const fileList = this.model.fileList.map(item => { return { ...item, fileType: 1 } })
            const scoreFileList = this.scoreFileList.map(item => { return { ...item, fileType: 2 } })
            const offerFileList = this.offerFileList.map(item => { return { ...item, fileType: 3 } })
            params.fileList = [...fileList, ...scoreFileList, ...offerFileList]
            console.log('submit', params)

            this.$refs.drawer.handleOkLoading(true)
            const res = await inductApplication(params).catch(() => {
              this.$refs.drawer.handleOkLoading(false)
              this.$message.error('操作失败，请稍后重试！')
            })
            this.$refs.drawer.handleOkLoading(false)
            if (res && res.status === 0) {
              this.$message.success(res.info.message)
              this.$emit('refreshTable')
              this.open(false)
            } else {
              this.$message.warning(res.info.message)
            }
          } else {
            // 拒绝入职
            params.intervieweeId = this.model.id
            console.log('reject', params)

            this.$refs.drawer.handleOkLoading(true)
            const res = await rejectInduction(params).catch(() => {
              this.$refs.drawer.handleOkLoading(false)
              this.$message.error('操作失败，请稍后重试！')
            })
            this.$refs.drawer.handleOkLoading(false)
            if (res && res.status === 0) {
              this.$message.success(res.info.message)
              this.$emit('refreshTable')
              this.open(false)
            } else {
              this.$message.warning(res.info.message)
            }
          }
        }
      })
    },
    // 清空表单
    formClear () {
      this.$nextTick(() => {
        this.form.resetFields()
        this.scoreFileList = []
        this.offerFileList = []
        if (this.$refs.uploadScore) this.$refs.uploadScore.clearFileList()
        if (this.$refs.uploadOffer) this.$refs.uploadOffer.clearFileList()
      })
    },
    cancel () {
      this.formClear()
      this.open(false)
    },
    handleUpload (fileList) {
      this.scoreFileList = fileList
    },
    handleOfferUpload (fileList) {
      this.offerFileList = fileList
    },
    
    filter (inputValue, path) {
      return path.some((option) => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1)
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}
</script>

<style lang="less">
.induct_application{
  .base_info{
    .ant-form-item{
      margin-bottom: 0;

      .ant-form-item-label label{
        color: #B3B3B3;
      }
    }
  }
}
</style>

